import React from 'react';
import _dialogLoader from './dialogLoader';
import { Delete } from '../pages/modals/Commons';
import * as _ from 'lodash';
import {
  onPDF,
  onExcel,
  onCansel,
  onApproval,
  onCreateComplete,
  deleteStatusComment,
} from '../services/LaborSafety';

/**
 * @description 労安帳票画面で共有して使う関数
 */

/**
 * @description 帳票ページで使う
 */

/**
 * @description 帳票情報管理Class
 */
class __FieldTreeFormStore {
  constructor() {
    this.store = null;
    this.callbacks = [];
  }

  setNotify(cb) {
    this.callbacks.push(cb);

    return () => {
      const index = this.callbacks.indexOf(cb);
      this.callbacks.splice(index, 1);
    };
  }

  setStore(data) {
    this.store = _.cloneDeep(data);
    _.each(this.callbacks, cb => cb(data));
  }

  getStore() {
    return _.cloneDeep(this.store);
  }
}

export const FieldTreeFormStore = new __FieldTreeFormStore();

/**
 * @description コメントを削除するダイアログを表示する
 */
export const ShowDeleteDialog = (field_id, field_tree_id, id, callback) => {
  _dialogLoader.close();
  _dialogLoader.show(Delete, {
    state: {
      callbacks: {
        modal: {
          delete: () =>
            deleteStatusComment(field_id, field_tree_id, id)
              .then(data => {
                if (data.result) {
                  _dialogLoader.close();
                  if (callback) {
                    callback(data.data.entities.field_tree_form_status);
                  }
                } else {
                  alert('削除に失敗しました。');
                }
              })
              .catch(() => alert('削除に失敗しました。')),
        },
      },
    },
  });
};

/**
 * @description 渡されたコンポーネントに必要な関数をあげる
 * @param {React.ComponentClass|Function} Component
 */
export const buttonWrapper = Component => {
  let props = {};
  const role_id = localStorage.getItem('role_id');

  switch (role_id) {
    default:
      props = { onExcel, onPDF, onApproval, onCansel, onCreateComplete };
      break;
  }
  const buttonWrapperInside = new_props => (
    <Component {...props} {...new_props} />
  );
  return buttonWrapperInside;
};



// WEBPACK FOOTER //
// ./src/utilities/LaborSafetyNotify.js